<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>门店管理</el-breadcrumb-item>
            <el-breadcrumb-item>门店列表{{ pageType }}</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <el-row :gutter="0">
                <el-col :span="12">
                    <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
                        style="width:300px;" @clear="getqiyeList" @change="getqiyeList">
                        <el-button slot="append" icon="el-icon-search" @click="getqiyeList"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="addDialog" v-if="caozuo_type !== '1'">添加门店</el-button>
                </el-col>
            </el-row>
            <el-row :gutter="0" class="el_row_two">
                <el-col :span="24">
                    <el-table :data="qiyeList" style="width: 100%" border stripe @row-click="rowClickEv">

                        <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->

                        <el-table-column v-if="pageType === 1">
                            <template scope="scope">
                                <el-radio :label="scope.$index + 1" v-model="mendianUidSelect"
                                    @change.native="getMendianInfo(scope.row.uid, scope.row.qiye_bianhao, scope.row.qiye_name, scope.row.qiye_mob)"></el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand" v-if="pageType === 4">
                            <template slot-scope="scope">
                                <el-table :data="scope.row.mingxi_list" stripe style="background-color: #f0f9f9;">
                                    <el-table-column prop="mingxi_money" label="明细金额"></el-table-column>
                                    <el-table-column prop="add_time" label="时间"></el-table-column>
                                </el-table>
                            </template>
                        </el-table-column>
                        <el-table-column prop="uid" label="uid" width="50"></el-table-column>
                        <el-table-column prop="qiye_bianhao" label="门店编号"></el-table-column>
                        <el-table-column prop="qiye_xuliehao" label="序列号" width="280"></el-table-column>
                        <el-table-column prop="qiye_name" label="门店名称"></el-table-column>

                        <el-table-column label="企业类型">
                            <template v-slot="scope">
                                {{ scope.row.qiye_type === 1 ? '直营连锁门店' : scope.row.qiye_type === 2 ? '特许加盟门店' : '亿业联盟门店' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="qiye_account_yingjiao" label="应缴总额"></el-table-column>
                        <el-table-column prop="qiye_account_xiaofei" label="已开单总额"></el-table-column>
                        <el-table-column prop="qiye_lxr" label="管理人"></el-table-column>
                        <el-table-column prop="qiye_mob" label="手机" width="130"></el-table-column>
                        <el-table-column prop="qiye_addr" label="地址"></el-table-column>
                        <el-table-column prop="qiye_tel" label="电话" width="130"></el-table-column>
                        <el-table-column prop="yong_flag" label="状态" v-if="false">
                            <template v-slot="scope">
                                <el-switch :active-value=1 :inactive-value=0 v-model="scope.row.yong_flag"></el-switch>
                            </template>
                        </el-table-column>

                    </el-table>
                </el-col>
            </el-row>
            <!-- 分页 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
                <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
            </el-pagination>        
        </el-card>
    </div>
</template>
<script>
import { checkMobileTest } from './config/validator'

export default {
    components: {

    },
    /* 
     caozuo_type   1 浏览 2 管理修改删除
     pageType 1 可以进行选择  4 显示所有明细 
     mingxi_type 1 2  用来显示客户明细
     mingxiMain_type 1 2  显示门店明细类别
    */
    props: ['caozuo_type', 'pageType', 'mingxi_type', 'mingxiMain_type'],
    data() {
        // var checkMobile = (rule, value, cb) => {
        //  const regMobil = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
        // if (regMobil.test(value)) {
        //    return cb()
        //  }
        //  cb(new Error('请输入合法的手机号!'))
        //  }
        return {
            yunying_qiye_uid: 0,
            datekey: Date.now(),
            options_qiye: [
                {
                    value: 1,
                    label: '直营连锁门店'
                }, {
                    value: 2,
                    label: '特许加盟门店'
                }, {
                    value: 3,
                    label: '亿业联盟门店'
                }

            ],
            mendianUidSelect: 0,
            mendianUidInfo: {},
            // 获取用户列表参数
            queryInfo: {
                //   token: window.sessionStorage.getItem('token'), // 递交数据，必须携带token ，进行验证
                C_type: 'get_list_more',
                C_table_name: 'qiye_list_more',
                query: '',
                pageNum: 1,
                pageSize: 10,
                CI_canshu01: this.mingxiMain_type,
                CI_canshu02: this.mingxi_type
            },
            qiyeList: [],
            //  recordCount: 0,
            total: 0,
            addDialogVisible: false,
            editDialogVisible: false,
            shigongDialogVisible: false,
            kucunDialogVisible: false,
            rukuDialogVisible: false,
            chukuDialogVisible: false,

            add_isDisable: false,
            //  添加表单数据项
            addForm: {
                C_type: 'qiye_add',
                qiye_bianhao: '',
                qiye_name: '',
                qiye_lxr: '',
                qiye_mob: '',
                qiye_xuliehao: '',
                qiye_type: ' ',
                qiye_tel: ' ',
                qiye_addr: ' ',
                pics_one: '',
                pics: ''
            },
            pics_one: '',
            pics: '',
            // 用于修改数据绑定
            editForm: {},
            // 表单规则项
            addFormRules: {
                qiye_type: [
                    { required: true, message: '选择类型', trigger: 'change', type: 'number' }
                ],
                qiye_name: [
                    { required: true, message: '请输入门店名称', trigger: 'blur' },
                    { min: 1, max: 30, message: '必须1到30位字符 ', trigger: 'blur' }
                ],
                qiye_lxr: [
                    { required: true, message: '请输入门店管理员', trigger: 'blur' },
                    { min: 1, max: 10, message: '必须1到10位字符', trigger: 'blur' }
                ],
                qiye_mob: [
                    { validator: checkMobileTest.bind(this.addForm && this.addForm.qiye_mob) }

                ]
            }
        };
    },
    created() {
        this.getqiyeList();
    },
    methods: {
        rowClickEv(data) {
      console.log(data)
      this.getMendianInfo(data.uid, data.qiye_bianhao, data.qiye_name, data.qiye_mob)
      this.mendianUidSelect = data.row
    },
        getMendianInfo(uid, bianhao, name, mob) {
            console.log(uid)
            // console.log(this.mendianUidSelect)
            //  this.mendianUidSelect = uid
            this.mendianUidInfo = {
                uid: uid,
                qiye_bianhao: bianhao,
                qiye_name: name,
                qiye_mob: mob
            }
            this.$emit('getMendianInfo', this.mendianUidInfo)
        },
        
        async getqiyeList() {
            const { data: res } = await this.$http.get('get_api', {
                params: this.queryInfo
            });
            // console.log(JSON.parse(res.data))
            this.qiyeList = JSON.parse(res.data)[0].dataList
            console.log(this.qiyeList)
            if (!this.qiyeList) return
            this.total = JSON.parse(res.data)[0].total;

            // console.log(this.total);
        },
        //  分页第一项下拉触发

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getqiyeList();
        },
        // 选择页数触发
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage;
            this.getqiyeList();
        },
         
        async qiyeInfo(uid) {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_table_name: 'qiye_info', uid: uid, C_type: 'get_info' }
            });
            // console.log(JSON.parse(res.data))
            console.log(res.data)
            if (JSON.parse(res.data)[0].status !== 200) {
                return this.$message.error('读取失败');
            }

            this.editForm = JSON.parse(res.data)[0].data[0];
        } 
    }
};
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
}

.el_row_two {
    margin-top: 30px;
}
</style>
